import { z } from 'zod';
import { idArray } from './shared.schema';

const filterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string(),
	}),
]);

export const outstandingBalanceSummaryReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

const commonFields = z.object({
	accountFilter: filterSchema.optional(),
	areaIds: idArray.optional(),
	asOfDate: z.iso.date(),
	branchIds: idArray.optional(),
	contactInfo: z.boolean().default(false),
	currentBalances: z.boolean().default(true),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	facilityName: z.string().optional(),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
	format: outstandingBalanceSummaryReportFormatSchema.default('csv'),
	subscriptionStatus: z.boolean().default(false),
});

export const outstandingBalanceSummaryParametersSchema = commonFields;

export type OutstandingBalanceSummaryParameters = z.infer<typeof outstandingBalanceSummaryParametersSchema>;
export type OutstandingBalanceSummaryReportFormat = z.infer<typeof outstandingBalanceSummaryReportFormatSchema>;
